import {NgModule} from '@angular/core';
// import {CustomTableComponent} from "./custom-table/custom-table.component";
import {CommonComponent} from './common.component';
import {NgSelectModule} from "@ng-select/ng-select";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {AgGridModule} from "ag-grid-angular";
import {NgbDropdownModule, NgbPaginationModule, NgbTypeaheadModule, NgbModalModule} from "@ng-bootstrap/ng-bootstrap";
import {ModalComponent} from './modal/modal.component';
import {BtnCellRenderer} from "./button-cell-renderer.component";
import {BtnCellRenderer1} from "./button-cell-renderer.component1";
import {BtnCellRenderer2} from "./button-cell-renderer2.component";
import {InputCellRenderer} from "./input-cell-renderer.component";
import {SelectCellRenderer} from "./select-cell-renderer.component";
import {DatepickerCellRenderer} from "./datepicker-cell-renderer.component";
import {AmountInputCellRenderer} from "./amount-input-cell-renderer.component";
import {AmountPercentInputCellRenderer} from "./amount-percent-input-cell-renderer.component";
import {CommonModule} from "@angular/common";
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import {BlockCopyPasteDirective} from "./block-copy-paste.directive";
import {DisableControlDirective} from "./disable-control.directive";
import {DropzoneDirective} from "./dropzone.directive";
import {DndDirective} from "./dnd.directive";
import {ProgressComponent} from "./progress/progress.component";
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { DialogConfirmComponent } from './dialog-confirm/dialog-confirm.component';
import { DndAppDirective } from './file-drag-n-drop.directive';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatButtonModule} from '@angular/material/button';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { ProgressComponentImg} from './progress-img/progress.component'
import {MatDialogModule} from '@angular/material/dialog';
import { SpinnerComponent } from './spinner/spinner.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoadingInterceptor } from './loading.interceptor';
import { MarkupInputCellRenderer } from './markup-input-cell-renderer.component copy';
import { BtnCellRendererEdit } from './button-cell-renderer-editable-component';
import { InputFieldRenderer } from './input-field-renderer-component';
import { SelectFieldRenderer } from './select-field-cell-renderer.component';
import { InputCheckBoxFieldRenderer } from './input-checkbox-field-renderer.component';
import { InputFieldWithoutDecimalRenderer } from './input-field-without-decimal';
import { ExchangeRateInput } from './exchange-rate-input-cell';
import { SelectCellRenderer1 } from './select-cell-renderer1.component';
import { DatepickerCellRenderer1 } from './datepicker-cell-renderer.component1';
import { EmiratesIdFormatterDirective } from './emirates-id-formatter.directive';
import { DisclaimerModalComponent } from './disclaimer-modal/disclaimer-modal.component';
import { DocumentsCellRendererComponent } from './documents-cell-renderer.component';
import { DocumentViewerModalComponent } from './document-viewer-modal.component';




@NgModule({
  declarations: [
    // CustomTableComponent,
    CommonComponent,
    ModalComponent,
    BtnCellRenderer,
    BtnCellRenderer1,
    BtnCellRenderer2,
    BtnCellRendererEdit,
    InputCellRenderer,
    InputFieldRenderer,
    InputCheckBoxFieldRenderer,
    SelectFieldRenderer,
    SelectCellRenderer,
    DatepickerCellRenderer,
    AmountInputCellRenderer,
    AmountPercentInputCellRenderer,
    MarkupInputCellRenderer,
    BlockCopyPasteDirective,
    DisableControlDirective,
    DropzoneDirective,
    DndDirective,
    ProgressComponent,
    DialogConfirmComponent,
    DndAppDirective, 
    DialogConfirmComponent ,
    ProgressComponentImg,
    SpinnerComponent,
    InputFieldWithoutDecimalRenderer,
    ExchangeRateInput,
    SelectCellRenderer1,
    DatepickerCellRenderer1,
    EmiratesIdFormatterDirective,
    DisclaimerModalComponent,
    DocumentsCellRendererComponent,
    DocumentViewerModalComponent
  ],
  imports: [
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    AgGridModule,
    NgbPaginationModule,
    NgbDropdownModule,
    NgbTypeaheadModule,
    NgbModalModule,
    CommonModule,
    SweetAlert2Module.forRoot(),
    PdfViewerModule,
    MatIconModule, MatInputModule, MatListModule, MatButtonModule, MatGridListModule, MatSnackBarModule, MatDialogModule,
    HttpClientModule

  ],
  exports: [
    // CustomTableComponent,
    ModalComponent,
    BtnCellRenderer,
    BtnCellRenderer1,
    BtnCellRenderer2,
    BlockCopyPasteDirective,
    DisableControlDirective,
    DropzoneDirective,
    DndDirective,
    ProgressComponent,
    PdfViewerModule,
    ProgressComponentImg,
    SpinnerComponent,
    EmiratesIdFormatterDirective,
    DisclaimerModalComponent,
    DocumentsCellRendererComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true
    }
  ],
  entryComponents: [ DialogConfirmComponent, DocumentViewerModalComponent ]

})
export class CustomCommonModule {
  constructor() {
  }
}
